import { transient, autoinject } from "aurelia-framework";
import { ManageVesselService } from "../../../../../services/vessels/manage-vessel.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { EntityTypeConfigurationHelper, EntityTypeConfigurationModel } from "../../../../../models/basics/basics.models";
import { Router } from "aurelia-router";
import { RightShipQiRouterConstants } from "../../../../../configuration/rightshipqi-router.constants";

@transient()
@autoinject()
export class MergeVesselDialog {

    public vesselId: number;
    public survivingVessel: any;
    public imo: string;
    public name: string;
    public vesselEntityTypes: EntityTypeConfigurationModel[];

    constructor(private manageVesselService: ManageVesselService,
        private dialogClientService: DialogClientService,
        private router: Router,
        private entityTypeConfigurationHelper: EntityTypeConfigurationHelper) {
        this.vesselEntityTypes = this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions(["VesselSearch"]);
    }

    activate(model: { vesselId: number, imo: string, vesselName: string }) {
        this.imo = model.imo;
        this.name = model.vesselName;
        this.vesselId = model.vesselId;
    }

    cancel() {
        this.dialogClientService.hide();
    }

    public onVesselSelected(vessel) {
        this.survivingVessel = vessel;
    }

    save() {
        return new Promise<void>((resolve, reject) => {

            this.manageVesselService.matchVessels(this.survivingVessel.id, [this.vesselId])
                .then(() => {

                    const prevInstruction = this.router.currentInstruction.previousInstruction;
                    const title = prevInstruction
                        ? prevInstruction.config.title
                        : null;

                    this.router.currentInstruction.config.title = title;

                    this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.VesselDetails, { id: this.survivingVessel.id }, { replace: true, trigger: true });

                    this.dialogClientService.hide();
                    resolve();
                }).catch(() => {
                    reject();
                });
        });
    }
}